import React from 'react';
import { motion } from 'framer-motion';
import {
  FaStar,
  FaArrowRight,
  FaMapMarkerAlt
} from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';
import './InternationalTours.css';

const InternationalTours = () => {

  const navigate = useNavigate();

  const tours = [
    {
      id: 1,
      slug: "rajasthan-royal-heritage-journey",
      title: "Rajasthan Royal Heritage Journey",
      location: "Rajasthan",
      rating: "4.9",
      image:
        "https://images.pexels.com/photos/35684261/pexels-photo-35684261.jpeg"
    },
    {
      id: 2,
      slug: "himalayan-nepal-escape",
      title: "Himalayan Nepal Escape",
      location: "Nepal",
      rating: "4.8",
      image:
        "https://images.pexels.com/photos/35560938/pexels-photo-35560938.jpeg"
    },
    {
      id: 3,
      slug: "bhutan-himalayan-escape",
      title: "Bhutan Himalayan Escape",
      location: "Bhutan",
      rating: "5.0",
      image:
        "https://images.pexels.com/photos/36114397/pexels-photo-36114397.jpeg"
    },
    {
      id: 4,
      slug: "kedarnath-badrinath-yatra",
      title: "Kedarnath & Badrinath Yatra",
      location: "Uttarakhand",
      rating: "4.7",
      image:
        "https://images.pexels.com/photos/15017640/pexels-photo-15017640.jpeg"
    },
    {
      id: 5,
      slug: "goa-coastal-escape",
      title: "Goa Coastal Escape",
      location: "Goa",
      rating: "4.8",
      image:
        "https://images.pexels.com/photos/2432269/pexels-photo-2432269.jpeg"
    },
    {
      id: 6,
      slug: "dibang-valley-anini-expedition",
      title: "Dibang Valley & Anini Expedition",
      location: "Arunachal",
      rating: "4.9",
      image:
        "https://images.pexels.com/photos/14840447/pexels-photo-14840447.jpeg"
    },
    {
      id: 7,
      slug: "arunachal-pradesh-tour",
      title: "Classic Arunachal Pradesh",
      location: "Tawang",
      rating: "4.8",
      image:
        "https://images.pexels.com/photos/35431358/pexels-photo-35431358.jpeg"
    },
    {
      id: 8,
      slug: "hampi-heritage-tour",
      title: "Hampi Heritage Tour",
      location: "Hampi",
      rating: "4.8",
      image:
        "https://images.pexels.com/photos/18331785/pexels-photo-18331785.jpeg"
    },
    {
      id: 9,
      slug: "ujjain-omkareshwar-jyotirlinga",
      title: "Ujjain & Omkareshwar Jyotirlinga",
      location: "Madhya Pradesh",
      rating: "4.9",
      image:
        "https://images.pexels.com/photos/36784973/pexels-photo-36784973.jpeg"
    },
  ];

  return (

    <section
      id="international-tours"
      className="international-section"
    >

      <div className="container">

        {/* HEADER */}

        <div className="section-header">

          <motion.span
            className="section-tag"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            PREMIUM DESTINATIONS
          </motion.span>

          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
           <span>Explore</span>  International <span>Tours</span>
          </motion.h2>

          <div className="title-line"></div>

        </div>

        {/* TOUR GRID */}

        <div className="tour-grid">

          {tours.map((tour, index) => (

            <motion.div
              key={tour.id}
              className="tour-card"

              initial={{
                opacity: 0,
                y: 100
              }}

              whileInView={{
                opacity: 1,
                y: 0
              }}

              transition={{
                duration: 0.8,
                delay: index * 0.08
              }}

              viewport={{
                once: false,
                amount: 0.2
              }}
            >

              {/* IMAGE */}

              <div className="card-image">

                <img
                  src={tour.image}
                  alt={tour.title}
                />

                <div className="image-overlay"></div>

                <div className="location-tag">
                  <FaMapMarkerAlt />
                  {tour.location}
                </div>

                <div className="rating-badge">
                  <FaStar />
                  {tour.rating}
                </div>

              </div>

              {/* CONTENT */}

              <div className="tour-content">

                <h3>{tour.title}</h3>

                <div className="card-footer">

                  <span className="trip-label">
                    Explore More
                  </span>

                  <button
                    className="explore-btn"
                    onClick={() => navigate(`/tour/${tour.slug}`)}
                  >
                    <FaArrowRight />
                  </button>

                </div>

              </div>

            </motion.div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default InternationalTours;